/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import {
  SET_REALM_IDPS_LOADING, SET_REALM_IDPS, SET_IDP_DETAILS, IDP_ERRORS,
  FETCH_IDP_REQUEST, FETCH_IDP_SUCCESS, FETCH_IDP_FAILURE
} from './types';
import { FETCH_UPDATE_DATA_FORM_VALUES } from "../passwordPolicies/types";

const initialState = {
  realmIdps: [],
  isRealmIdpsLoading: true,
  idpDetails: {},
  idpDetailsData: {},
  idpErrors: null
}

export const identityProvidersReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case SET_REALM_IDPS_LOADING:
      return {
        ...state,
        isRealmIdpsLoading: action.isRealmIdpsLoading
      }
    case SET_REALM_IDPS:
      return {
        ...state,
        realmIdps: action.realmIdps,
        isRealmIdpsLoading: false
      }
    case SET_IDP_DETAILS:
      return {
        ...state,
        idpDetails: action.idpDetails
      }
    case FETCH_IDP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_IDP_SUCCESS:
      return {
        ...state,
        idpDetailsData: action.idpDetailsData,
        loading: false,
        error: null
      };

    case FETCH_IDP_FAILURE:
      return {
        ...state,
        idpDetailsData: {},
        loading: false,
        error: action.error
      };
    case FETCH_UPDATE_DATA_FORM_VALUES:
      return {
        ...state,
        idpDetailsData: {},
        loading: false,
        error: action.error
      };
    case IDP_ERRORS:
      return {
        ...state,
        idpErrors: action.idpErrors
      }
    default:
      return state;
  }
};